import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
img {
    vertical-align: bottom;
}
.top-container {
  letter-spacing: -0.5px;
    font-family: 'Nimbus Sans', normal;
    padding-top: calc(8px * 2);
    padding-bottom: 32px;
    background-color: #f1f1f1;
    min-height: calc(8px * 100);
    color: #475359;
}
.finished-saved-lang {
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
    text-align: right;
    letter-spacing: 0;
}
a.finish-app-link {
    text-decoration: none;
    color: #006894;
}
.view-all-accounts {
  max-width: 544px;
  margin: 0 auto;
    padding-top: calc(8px * 3);
    padding-left: calc(8px * 2);
    padding-bottom: calc(8px * 3);
    line-height: 22px;
    letter-spacing: 0;
    color: #475359;
}
.view-all-link {
    color: #006894;
    font-weight: bold;
    text-decoration: none;
}
.disclaimer {
    margin: 24px auto;
    max-width: 580px;
}
@media (max-width: 1080px) {
    .top-container {
        padding-left: 32px;
        padding-right: 32px;
    }
}
@media (max-width: 720px) {
    .finished-saved-lang {
        text-align: center;
    }
    .top-container {
        padding-left: calc(24px / 2);
        padding-right: calc(24px / 2);
    }
}
`;

export default styles;